import { render } from "./PlayerInSittingTeam.vue?vue&type=template&id=4e1819a0&scoped=true"
import script from "./PlayerInSittingTeam.vue?vue&type=script&lang=js"
export * from "./PlayerInSittingTeam.vue?vue&type=script&lang=js"

import "./PlayerInSittingTeam.vue?vue&type=style&index=0&id=4e1819a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1819a0"]])

export default __exports__